export enum NotificationType {
  CNP_START_FOLLOW_YOU = 'CNP_START_FOLLOW_YOU',
  CNP_REACT_TO_THREAD = 'CNP_REACT_TO_THREAD',
  CNP_REACT_TO_COMMENT = 'CNP_REACT_TO_COMMENT',
  CNP_COMMENT_IN_THREAD = 'CNP_COMMENT_IN_THREAD',
  CNP_VOTE_IN_CASE = 'CNP_VOTE_IN_CASE',
}
